document.addEventListener('DOMContentLoaded', function() {
    // Only apply mobile functionality on mobile devices
    if (window.innerWidth <= 767) {
        const footerItems = document.querySelectorAll('.footer-section-item');
        
        footerItems.forEach(item => {
            const toggle = item.querySelector('.mobile-toggle');
            const titleContainer = item.querySelector('.footer-title-container');
            
            // Add click event to both toggle button and title container
            [toggle, titleContainer].forEach(element => {
                if (element) {
                    element.addEventListener('click', function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        
                        // Close other sections
                        footerItems.forEach(otherItem => {
                            if (otherItem !== item) {
                                otherItem.classList.remove('expanded');
                            }
                        });
                        
                        // Toggle current section
                        item.classList.toggle('expanded');
                    });
                }
            });
        });
    }
    
    // Handle window resize
    window.addEventListener('resize', function() {
        if (window.innerWidth > 767) {
            // Remove expanded classes on desktop
            const footerItems = document.querySelectorAll('.footer-section-item');
            footerItems.forEach(item => {
                item.classList.remove('expanded');
            });
        }
    });
});
